export default "__VITE_ASSET__53b307c3__"